import { create } from 'zustand'

interface EditingFarmboostState {
  selectedMoleIds: string[]
  selectedBoostFarmIds: number[]
}
type UpdateEditingFarmboostState = Partial<EditingFarmboostState>

interface EditingFarmboost extends EditingFarmboostState {
  set: (newState: UpdateEditingFarmboostState) => void
}

const useEditingFarmboostStore = create<EditingFarmboost>((set) => ({
  selectedMoleIds: [],
  selectedBoostFarmIds: [],
  set: (newState: UpdateEditingFarmboostState) => set(() => newState),
}))

export const useEditingFarmboost = (): EditingFarmboostState => {
  return useEditingFarmboostStore()
}

export const getEditingFarmboost = (): EditingFarmboostState => {
  return useEditingFarmboostStore.getState()
}

export const setEditingFarmboost = (newState: UpdateEditingFarmboostState) => {
  useEditingFarmboostStore.getState().set(newState)
}
